<mat-form-field
  appearance="outline"
  [ngClass]="{
    failed: !!UOMValidation || !validSnapshot || !!warning,
    capitalized: capitalized,
    'ng-warning': isWarningDisplayed,
  }"
  class="miq-form-input"
>
  <ng-container *ngIf="!isMaskedValue; else maskedInput">
    <mat-select
      hideSingleSelectionIndicator="true"
      #select
      [placeholder]="placeholder | xTranslate"
      [required]="required"
      [formControl]="fc"
      [panelClass]="panelClass"
      (selectionChange)="onChange($event.value)"
      (blur)="blur.emit($event)"
      disableOptionCentering
    >
      <mat-option *ngIf="showNullOption" (click)="select.close()" [value]="null">--</mat-option>
      <mat-option
        (click)="select.close()"
        *ngFor="let val of values"
        [value]="val[dataKey]"
        [disabled]="val.disabled"
        [ngClass]="{ capitalized: capitalized }"
      >
        {{ val.value }}
      </mat-option>
    </mat-select>
  </ng-container>
  <ng-template #maskedInput>
    <input matInput autocomplete="new-password" type="password" [disabled]="true" [value]="currentValue" />
  </ng-template>
</mat-form-field>
